import {MAX_ALLOWED_ATTACHMENTS} from '@hconnect/common/consts'
import {headlineSx, imageBoxSx} from '@hconnect/common/styles'
import {Attachment} from '@hconnect/common/types'
import {getUniqueAttachments} from '@hconnect/common/utils'
import {CardSectionTitle} from '@hconnect/uikit/src/lib2'
import {useUpmPlant} from '@hconnect/upm'
import {useHasPermission} from '@hproduce/permissions'
import {Box, Divider} from '@mui/material'
import {AttachmentItem, AttachmentItemsDisplay} from '@widgets/common-attachments'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {ProcessWorkOrderAttachment} from '../../types'

type Props = {
  attachments: Attachment[] | ProcessWorkOrderAttachment[] | undefined
  plantId: string
}

export const ShiftTaskAttachmentsContainer = ({attachments, plantId}: Props) => {
  const [activeAttachmentId, setActiveAttachmentId] = useState<string | number | undefined>(
    undefined
  )
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const upmPlant = useUpmPlant({plantId, shouldRaiseError: false})
  const hasPermission = useHasPermission({plantId, countryId: upmPlant?.country ?? ''})
  // TODO: this permission is SH specific, should be removed for PWO tasks
  const canViewDocuments = hasPermission('VIEW_DOCUMENTS')

  const uniqueAttachments = getUniqueAttachments<string | number>(
    attachments,
    MAX_ALLOWED_ATTACHMENTS
  )

  if (!canViewDocuments || !uniqueAttachments) {
    return null
  }

  return (
    <Box>
      <CardSectionTitle sx={headlineSx()}>
        {t('shiftEvent.attachments')} {`${uniqueAttachments.length}/${MAX_ALLOWED_ATTACHMENTS}`}
      </CardSectionTitle>
      <Divider sx={{borderColor: 'divider'}} />
      <Box component="span" sx={imageBoxSx()}>
        {uniqueAttachments.map((attachment, index) => (
          <AttachmentItem
            key={attachment.id}
            attachment={attachment}
            setActiveAttachmentId={setActiveAttachmentId}
            disableError={activeAttachmentId !== undefined || !!index}
          />
        ))}
      </Box>
      {activeAttachmentId !== undefined && (
        <AttachmentItemsDisplay
          attachments={uniqueAttachments}
          activeAttachmentId={activeAttachmentId}
          onClose={() => setActiveAttachmentId(undefined)}
        />
      )}
    </Box>
  )
}
